<template>
    <div class="home1">
        <FloatingBtn />
    </div>
</template>
<script>
    import FloatingBtn from './../components/FloatingBtn.vue'
    const axios = require('axios')
    axios.defaults.withCredentials=true; // carry cookie
    
    const config = require('./../config/index.js')
    export default {
        mounted() {
            this.getGameLink()
        },
        components: {
            FloatingBtn
        },
        methods: {
            getGameLink() {
                var self = this
                var base =
                    config.accountAuth.baseApi + '?vendor=' + config.accountAuth.vendor + '&cmd=' + config.getGameLink

                axios.get(base)
                    .then(function (response) {
                        // handle success

                        if(response.data.errorCode == 0){
                            self.$store.dispatch('saveLogin', response.data.result)
                            self.$router.push('/game')
                        }

                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    });
            }
        }
    }
</script>
<style lang="less" scoped>
    .home1{
        height: 100vh;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./../assets/img/fake-loader.png');
        background-position: center;
    }
    @media (orientation: portrait) {
        .home1{
            width: 100vh;
            height: 100vw;
        }
    }
</style>